import PageSkeleton from './page-skeleton.vue';

export default PageSkeleton;
